import React from "react";
import { Link } from "react-router-dom";

export const PublicShell = ({ children }) => (
  <div className="min-h-screen bg-slate-50 flex flex-col">
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-2">
        <Link to="/" className="flex flex-col shrink-0" data-testid="public-brand-logo">
          <img src="/branding/zanitel_logo.png" alt="Zeeptel" className="h-8 sm:h-9 w-auto" />
          <span className="hidden sm:block text-[10px] font-semibold tracking-[0.18em] uppercase text-slate-400 mt-0.5 pl-0.5">
            connecting the world
          </span>
        </Link>
        <div className="flex items-center gap-2">
          <Link to="/login" data-testid="public-login" className="px-4 py-2 rounded-xl text-sm font-semibold text-slate-700 hover:bg-slate-100 transition-colors">
            Log In
          </Link>
          <Link to="/register" data-testid="public-signup" className="px-4 py-2 rounded-xl bg-[#2563EB] text-white text-sm font-semibold hover:bg-[#1D4ED8] transition-colors shadow-sm">
            Get Started
          </Link>
        </div>
      </div>
    </header>

    {children}

    <footer className="bg-[#1E3A8A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
        <span className="font-heading font-bold">© 2026 ZEEPTEL · zeeptel.com</span>
        <div className="flex items-center gap-3 text-xs text-blue-300">
          <Link to="/rates" className="hover:text-white transition-colors">Rates</Link>
          <Link to="/about" className="hover:text-white transition-colors">About</Link>
          <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  </div>
);
